<template>
  <div>
    <template v-if="!loading">

      <b-row align-v="center">
        <b-col lg="4">
          <h6 class="h6-semibold-azure-uppercase">{{ current.pad(2) }}</h6>
          <h3 class="h3-semibold-black mb-5">Che tipo di fornitura ti serve?</h3>
        </b-col>
        <b-col lg="6" offset-lg="2">
          <b-row>
            <b-col cols="6">
              <div class="config-button-element" @click="setEnergyType('luce')">
                <i class="sgri-luce-bicolore">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <div class="title h6-semibold-azure-uppercase">Luce</div>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="config-button-element" @click="setEnergyType('gas')">
                <i class="sgri-gas-bicolore">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <div class="title h6-semibold-azure-uppercase">Gas</div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

    </template>
  </div>
</template>

<script>
export default {
  name: 'Step-2',
  data() {
    return {
      thisStep: 2,
      localOptions: null,
      loading: true,
    }
  },
  props: {
    steps: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    options: {
      type: [Array, Object],
      required: true
    }
  },
  created() {
    if(this.options.step < this.thisStep) this.$router.push({name:'step-1', query: { comune: this.options.comune }})
    this.$emit('setCurrent', this.thisStep)
    this.localOptions = {...this.options};
    this.loading = false;
    this.trackFbViewContent('configuratore', 'step-1');
  },
  methods: {
    setEnergyType(type) {
      this.localOptions.energyType = type;
      let steps = type == 'luce' ? 4 : 3;
      //let steps = type == 'luce' ? 4 : 2;
      let nextStep = type == 'luce' ? 3 : 6;
      let realNextStep = type == 'luce' ? 4 : 4;

      if(this.localOptions.propertyType === 'impresa')
      {
        steps = 4;
        nextStep = 4;
        realNextStep = 3;
      }
      //let realNextStep = type == 'luce' ? 4 : 6;
      this.$emit('changeSteps',steps);
      this.$emit('nextStep',nextStep, realNextStep, this.localOptions)
    },
  },
}
</script>

<style scoped lang="scss">
</style>